/* Great Lakes Lavender Farm — AI picture note fixes v1 (works on top of snippets/gllf-ai-image-badge.liquid).
   - Tapping the badge on a phone opened the full-screen photo viewer behind the note (the product page's
     tap-to-zoom caught the tap first), so the screen seemed to disappear. Taps on the badge now only open/close the note.
   - The note gets a close (×) button.
   - The note closes when a menu, the search panel or the shortlist opens. */
(function () {
  'use strict';
  if (window.__gllfAiNoteV1) return;
  window.__gllfAiNoteV1 = true;
  function tip() { return document.getElementById('gllf-ai-tip'); }
  function close() { document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true })); }

  /* Window capture runs before the theme's own listeners, so the photo viewer never sees the tap.
     A phone fires hover + focus (which open the note) just before the click, so "was it already open?"
     is read when the finger goes down. */
  var wasOpen = false;
  function isOpen(b) { return b.getAttribute('aria-expanded') === 'true' && tip() && tip().dataset.open === 'true'; }
  var touch = false;
  window.addEventListener('pointerdown', function (e) { touch = e.pointerType === 'touch' || e.pointerType === 'pen'; var b = e.target && e.target.closest && e.target.closest('.gllf-ai-badge'); wasOpen = !!(b && isOpen(b)); }, true);
  /* After a tap, phones send a "mouse left" to the badge, which closed the note right away. On touch, the note
     stays until the × , a second tap, or a tap somewhere else. */
  window.addEventListener('mouseleave', function (e) { if (touch && e.target && e.target.closest && e.target.closest('.gllf-ai-badge, .gllf-ai-tip')) e.stopPropagation(); }, true);
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.gllf-ai-badge');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var open = e.pointerType === 'mouse' || !e.pointerType ? isOpen(b) : wasOpen;
    wasOpen = false;
    if (open && e.pointerType !== 'mouse') { close(); return; }
    b.dispatchEvent(new MouseEvent('mouseenter')); /* the badge opens its note on hover; a tap does the same */
  }, true);

  function addClose(t) {
    if (!t || t.querySelector('.gllf-ai-tip__x')) return;
    var x = document.createElement('button'); x.type = 'button'; x.className = 'gllf-ai-tip__x'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '<span aria-hidden="true">×</span>';
    x.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      close();
    });
    t.insertBefore(x, t.firstChild);
  }
  function watch() {
    var t = tip(); if (!t) return false;
    addClose(t);
    new MutationObserver(function () { addClose(t); }).observe(t, { childList: true });
    return true;
  }
  if (!watch()) document.addEventListener('DOMContentLoaded', watch);

  /* Close the note when a menu, the search panel or the shortlist opens. */
  document.addEventListener('toggle', function (e) { if (e.target && e.target.open && tip() && tip().dataset.open === 'true') close(); }, true);
  new MutationObserver(function () {
    var h = document.documentElement.classList;
    if ((h.contains('gllf-mega-panel-open') || h.contains('sp-lock') || h.contains('gllf-ss-open')) && tip() && tip().dataset.open === 'true') close();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();
